import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
  Select,
  Collapse,
  Popconfirm,
} from 'antd';
import _ from 'lodash';
import IntlMessage from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import routeSegmentsApi from '../../api/route-segments';
import dayjs from 'dayjs';
import useTime from '../../hooks/useTime';
import rateHistoriesApi from '../../api/rate-histories';
import { formatCurrencyCustom } from '../../utils/helpers';

const { Text } = Typography;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const weekDayMapFr = {
  Sunday: 'Dimanche',
  Monday: 'Lundi',
  Tuesday: 'Mardi',
  Wednesday: 'Mercredi',
  Thursday: 'Jeudi',
  Friday: 'Vendredi',
  Saturday: 'Samedi',
};

const RoutePriceForm = (props) => {
  const { open, onClose, currentData, routeId } = props;
  console.log('currentData: ', currentData);

  const isMounted = useRef(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const { formatAsISOString } = useTime();
  const [options, setOptions] = useState([]);
  const [total, setTotal] = useState(0);
  const [groupHistory, setGroupHistory] = useState([]);
  const [maps, setMaps] = useState([
    { segment_id: null, price: null, title: null },
  ]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });

  useEffect(() => {
    isMounted.current = true;
    async function fetch() {
      if (isMounted.current) {
        var filter_option = {
          page: 1,
          limit: 1000,
          keyword: '',
          order_by: 'id',
          order_dir: 'DESC',
          filter_name: ['route_id', 'status'],
          filter_value: [currentData?.id, 1],
        };

        let options = await routeSegmentsApi.getAll(filter_option);
        console.log('chekc options: ', options);
        setOptions(options.data);

        setMaps(
          options.data.map((segment) => ({
            segment_id: segment.id,
            price: segment.from_price || null,
            title: `${segment.start_stop.title} - ${segment.end_stop.title}`,
            weekdays: ['0', '1', '2', '3', '4', '5', '6'],
          })),
        );
      }
    }
    fetch();
  }, [currentData]);

  useEffect(() => {
    const fetchDataHistory = async () => {
      if (maps) {
        let filter_option;
        const mapsIds = maps.map((item) => item.segment_id);
        const filter_segment_id = mapsIds.join(',');
        if (filter_segment_id) {
          filter_option = {
            page: 1,
            limit: 1000,
            keyword: '',
            order_by: 'id',
            order_dir: 'DESC',
            filter_name: ['segment_id'],
            filter_value: [filter_segment_id],
          };
          const res = await rateHistoriesApi.getGroup(filter_option);
          setGroupHistory(res.data);
          setTotal(res.total);
        }
      }
    };
    fetchDataHistory();
  }, [maps]);
  const handleChangeYear = (e) => {
    console.log(e);
    if (e.includes('1')) {
      form.setFieldsValue({
        to_date: dayjs(form.getFieldValue('from_date')).add(365, 'day'),
      });
    } else {
      form.setFieldsValue({
        to_date: dayjs(form.getFieldValue('from_date')).add(1, 'month'),
      });
    }
  };

  const [mode, setMode] = useState('date');
  // Jour = single calendar day only (based on selected date, not leftover Date range / all weekdays)
  const resolveDayModePayload = (values, mapsWeekdays) => {
    const fromDate = values.from_date;
    if (mode === 'day') {
      const weekday = String(dayjs(fromDate).day());
      return {
        from_date: fromDate,
        to_date: fromDate,
        weekdays: mapsWeekdays.map(() => [weekday]),
      };
    }
    return {
      from_date: fromDate,
      to_date: values.to_date,
      weekdays: mapsWeekdays,
    };
  };
  const onChangeMode = (value) => {
    setMode(value);
    if (value === 'day') {
      const fromDate = form.getFieldValue('from_date') || dayjs();
      const weekday = String(dayjs(fromDate).day());
      form.setFieldsValue({
        to_date: fromDate,
      });
      setMaps((prev) =>
        prev.map((item) => ({
          ...item,
          weekdays: [weekday],
        })),
      );
    } else if (value === 'date') {
      const fromDate = form.getFieldValue('from_date') || dayjs();
      form.setFieldsValue({
        to_date: dayjs(fromDate).add(30, 'day'),
      });
      setMaps((prev) =>
        prev.map((item) => ({
          ...item,
          weekdays: ['0', '1', '2', '3', '4', '5', '6'],
        })),
      );
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then(
        (values) => {
          const data = { ...values };
          data['route_id'] = routeId;

          const mapsWeekdays = maps.map((item) => [...item.weekdays]);
          const resolved = resolveDayModePayload(data, mapsWeekdays);
          data.from_date = resolved.from_date;
          data.to_date = resolved.to_date;

          const segmentIds = maps.map((item) => item.segment_id);
          const weekdays = resolved.weekdays;
          const prices = maps.map((item) => item.price);

          const combinedData = _.zipWith(prices, segmentIds, (p, s) => ({
            price: p,
            segment_id: s,
          }));
          const payloadData = combinedData.filter(
            (item) => item.price !== null && item.segment_id !== null,
          );
          console.log('combinedData: ', payloadData);
          const segment_payload = payloadData.map((item) => item.segment_id);
          const price_payload = payloadData.map((item) => item.price);
          data['segment_id'] = segment_payload;
          data['price'] = price_payload;
          data.weekdays = weekdays;

          data.from_date = formatAsISOString(data.from_date);
          data.to_date = formatAsISOString(data.to_date);

          const payload = _.cloneDeep(data);
          console.log('values: ', values);

          console.log('payload: ', payload);
          const historyPayload = { ...data };

          console.log('check weekday: ', historyPayload.week_days);
          const weekdaysMap = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ];
          historyPayload.week_days = data.weekdays.map((week) =>
            week.map((item) => weekdaysMap[Number(item)] || 'Sunday'),
          );

          if (payload?.year) {
            if (!payload?.year.includes('1')) {
              delete payload.year;
            }
          }
          delete historyPayload.weekdays;
          delete historyPayload.route_id;
          delete payload.route_id;
          console.log(' historyPayload: ', historyPayload);

          Promise.all([
            routeSegmentsApi.create_multiple(payload),
            rateHistoriesApi.create_multiple(historyPayload),
          ])
            .then((res) => {
              if (res?.statusCode === 400) {
                Modal.error({
                  title: res?.message,
                  okText: intl.formatMessage({ id: 'global.close' }),
                });
                setLoading(false);
              } else {
                setLoading(false);
                handleCancel();
                props.onReload();
              }
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        },
        // }
      )
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const handleDeletePrice = (currentData) => {
    setLoading(true);
    form
      .validateFields()
      .then(
        (values) => {
          const data = { ...values };
          data['route_id'] = routeId;

          const mapsWeekdays = maps.map((item) => [...item.weekdays]);
          const resolved = resolveDayModePayload(data, mapsWeekdays);
          data.from_date = resolved.from_date;
          data.to_date = resolved.to_date;

          const segmentIds = maps.map((item) => item.segment_id);
          const prices = maps.map((item) => item.price);

          const combinedData = _.zipWith(prices, segmentIds, (p, s) => ({
            price: p,
            segment_id: s,
          }));
          const payloadData = combinedData.filter(
            (item) => item.price !== null && item.segment_id !== null,
          );
          console.log('combinedData: ', payloadData);
          data['segment_id'] = [currentData?.segment_id];
          data.weekdays =
            mode === 'day'
              ? [[String(dayjs(resolved.from_date).day())]]
              : [currentData.weekdays];
          data.from_date = formatAsISOString(data.from_date);
          data.to_date = formatAsISOString(data.to_date);

          const payload = _.cloneDeep(data);
          console.log('values: ', values);

          console.log('payload: ', payload);
          const historyPayload = { ...data };
          historyPayload.price = [0];
          const weekdaysMap = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ];
          historyPayload.week_days = `${
            data.weekdays.map((week) =>
              week.map((item) => weekdaysMap[Number(item)] || 'Sunday'),
            )[0]
          }`;

          if (payload?.year) {
            if (!payload?.year.includes('1')) {
              delete payload.year;
            }
          }
          historyPayload.params = JSON.stringify({ action: 'delete' });

          delete historyPayload.weekdays;
          delete historyPayload.route_id;
          delete payload.route_id;
          console.log(' historyPayload: ', historyPayload);
          console.log(' payload: ', payload);

          Promise.all([
            routeSegmentsApi.deleteMultipleRate(payload),
            rateHistoriesApi.create_multiple(historyPayload),
          ])
            .then((res) => {
              if (res?.statusCode === 400) {
                Modal.error({
                  title: res?.message,
                  okText: intl.formatMessage({ id: 'global.close' }),
                });
                setLoading(false);
              } else {
                setLoading(false);
                handleCancel();
                props.onReload();
              }
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        },
        // }
      )
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleCancel = () => {
    onClose();
  };

  const columns = [
    {
      title: <IntlMessage id="global.created_at" />,
      dataIndex: 'created_at',
      width: 150,
      render: (text, record, index) => {
        return (
          <Text>{dayjs(record?.created_at).format('DD/MM/YYYY HH:mm')}</Text>
        );
      },
    },
    {
      title: <IntlMessage id="global.segment" />,
      dataIndex: 'seat',
      render: (text, record, index) => {
        return record.segment.start_stop.title &&
          record.segment.end_stop.title ? (
          <Text>
            {record.segment.start_stop.title} {record.segment.end_stop.title}
          </Text>
        ) : null;
      },
    },
    {
      title: <IntlMessage id="global.price" />,
      dataIndex: 'price',
      render: (text, record, index) => {
        return (
          <Text>
            {formatCurrencyCustom(
              +record.price,
              JSON.parse(record?.route?.operator?.params || '{}'),
            )}
          </Text>
        );
      },
    },
    {
      title: <IntlMessage id="history.from_date" />,
      dataIndex: 'from_date',
      width: 150,
      render: (text, record, index) => {
        return <Text>{dayjs(record?.from_date).format('DD/MM/YYYY')}</Text>;
      },
    },
    {
      title: <IntlMessage id="history.to_date" />,
      dataIndex: 'to_date',
      width: 150,
      render: (text, record, index) => {
        return <Text>{dayjs(record?.to_date).format('DD/MM/YYYY')}</Text>;
      },
    },
    {
      title: <IntlMessage id="global.weekdays" />,
      dataIndex: 'week_days',
      render: (text, record) => {
        const translated = record.week_days
          ?.split(',')
          .map((day) => weekDayMapFr[day.trim()] || day)
          .join(', ');

        return <Text>{translated}</Text>;
      },
    },
  ];

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] },
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const handleCreateStatus = () => {
    let data = {};
    const segmentIds = maps.map((item) => item.segment_id);
    const mapsWeekdays = maps.map((item) => item.weekdays);
    const resolved = resolveDayModePayload(
      {
        from_date: form.getFieldValue('from_date'),
        to_date: form.getFieldValue('to_date'),
      },
      mapsWeekdays,
    );
    data.segment_id = segmentIds;
    data.weekdays = resolved.weekdays;
    data.from_date = formatAsISOString(resolved.from_date);
    data.to_date = formatAsISOString(resolved.to_date);
    data.status = form.getFieldValue('status');
    // data.cabin_id = cabin.id;
    // console.log(data);
    routeSegmentsApi
      .updateMultipleStatus(data)
      .then(() => {
        setLoading(false);
        Modal.success({
          title: 'Success',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        props.onReload();
        handleCancel();
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
  };

  const itemsNest = [
    {
      key: '1',
      label: 'Status',
      children: (
        <>
          <Form.Item name="status">
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Button type="primary" size="small" onClick={handleCreateStatus}>
            Valider
          </Button>
        </>
      ),
    },
  ];

  const handleChangeCheckBox = (index, item, value) => {
    console.log(item, value);
    setMaps((prev) => {
      const newMaps = [...prev];
      newMaps[index].weekdays = value;
      return newMaps;
    });
  };
  const tabItems = [
    {
      key: '1',
      label: <IntlMessage id="global.segment" />,
      children: (
        <React.Fragment>
          <Row justify={'start'} style={{ width: '100%' }}>
            <Col span={4}>
              <Form.Item
                name={'mode'}
                initialValue={'date'}
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id="global.requiredfeild" />,
                  },
                ]}>
                <Select
                  placeholder="Select mode"
                  onSelect={onChangeMode}
                  options={[
                    {
                      value: 'date',
                      label: <IntlMessage id="global.date" />,
                    },
                    {
                      value: 'day',
                      label: <IntlMessage id="global.day" />,
                    },
                  ]}></Select>
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                label={mode === 'date' && <IntlMessage id="global.from_date" />}
                name="from_date"
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id="global.requiredfield" />,
                  },
                ]}>
                <DatePicker
                  // showTime
                  format={'DD/MM/YYYY'}
                  style={{ width: '70%' }}
                  onChange={(date) => {
                    if (mode === 'day' && date) {
                      const weekday = String(dayjs(date).day());
                      form.setFieldsValue({ to_date: date });
                      setMaps((prev) =>
                        prev.map((item) => ({
                          ...item,
                          weekdays: [weekday],
                        })),
                      );
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {mode === 'date' && (
              <Col span={10}>
                <Form.Item
                  label={<IntlMessage id="global.to_date" />}
                  labelCol={{ span: 8 }}
                  name="to_date"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                  ]}>
                  <DatePicker
                    // showTime
                    format={'DD/MM/YYYY'}
                    style={{ width: '70%' }}
                    // onChange={handleDate}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
          <Space size="middle" direction="vertical" style={{ width: '100%' }}>
            {maps.map((item, index) => {
              console.log('item: ', item);
              return (
                <>
                  <Checkbox.Group
                    style={{ width: '100%' }}
                    value={item?.weekdays}
                    onChange={(value) =>
                      handleChangeCheckBox(index, item, value)
                    }>
                    <Row>
                      <Col span={3}>
                        <Checkbox value="1" checked>
                          Lundi
                        </Checkbox>
                      </Col>
                      <Col span={3}>
                        <Checkbox value="2" defaultChecked>
                          Mardi
                        </Checkbox>
                      </Col>
                      <Col span={3}>
                        <Checkbox value="3">Mercredi</Checkbox>
                      </Col>
                      <Col span={3}>
                        <Checkbox value="4">Jeudi</Checkbox>
                      </Col>
                      <Col span={3}>
                        <Checkbox value="5">Vendredi</Checkbox>
                      </Col>
                      <Col span={3}>
                        <Checkbox value="6">Samedi</Checkbox>
                      </Col>
                      <Col span={3}>
                        <Checkbox value="0">Dimanche</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>

                  <Flex align="center" gap={12} key={index}>
                    <Input value={item.title} readOnly />
                    <InputNumber
                      min={1}
                      placeholder="Prix"
                      formatter={(value) => {
                        if (
                          value === undefined ||
                          value === null ||
                          value === ''
                        ) {
                          return '';
                        }

                        const currencySymbol = (
                          JSON.parse(currentData?.operator?.params || '{}')
                            ?.sale_currency_symbol || 'CFA'
                        )
                          .toString()
                          .trim();

                        const formatted = `${value}`
                          .replace(/\s*[A-Za-z]+\s*$/g, '')
                          .replace(/\s/g, '') // remove existing spaces
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // 👈 dùng space thay vì comma

                        return `${formatted} ${currencySymbol}`;
                      }}
                      parser={(value) => {
                        if (!value) return '';
                        return value
                          .toString()
                          .replace(/\s/g, '') // 👈 remove space
                          .replace(/[^\d.]/g, '');
                      }}
                      value={item.price}
                      onChange={(value) => handleChangePrice(value, index)}
                      style={{ width: 200 }}
                    />
                    <Popconfirm
                      title="Annulation départ"
                      description="Êtes-vous sûr de vouloir enlever ce départ ?"
                      onConfirm={() => handleDeletePrice(item)}
                      okText="Oui"
                      cancelText="Non">
                      <Button
                        danger
                        type="primary"
                        variant="solid"
                        // onClick={() => handleDeletePrice(item)}
                        disabled={!item.price}>
                        Annuler
                      </Button>
                    </Popconfirm>
                  </Flex>
                </>
              );
            })}
          </Space>

          <Collapse
            items={itemsNest}
            style={{ marginTop: '20px' }}
            defaultActiveKey={'1'}
          />
        </React.Fragment>
      ),
    },
    {
      key: '2',
      label: <IntlMessage id="global.history" />,
      children: (
        <React.Fragment>
          <Table
            columns={columns}
            dataSource={groupHistory}
            tableLayout="auto"
            onChange={onChangeTable}
            bordered
            pagination={{
              total: total,
              showSizeChanger: true,
              current: filter.page,
              pageSize: filter.limit,
            }}
            scroll={{ x: 'max-content' }}
          />
        </React.Fragment>
      ),
    },
  ];

  const handleChangePrice = (value, index) => {
    setMaps((prev) => {
      const newMaps = [...prev];
      newMaps[index].price = value;
      return newMaps;
    });
  };

  return (
    <React.Fragment>
      <Modal
        title={<IntlMessage id="global.add" />}
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="60%"
        onOk={handleSubmit}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessage id="global.cancel" />}
          </Button>,
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={handleSubmit}>
            {<IntlMessage id="global.save" />}
          </Button>,
        ]}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Form
            {...layout}
            form={form}
            labelAlign="left"
            initialValues={{
              weekdays: ['0', '1', '2', '3', '4', '5', '6'],
              from_date: dayjs(),
              to_date: dayjs().add(30, 'day'),
              price: 1,
              status: 1,
            }}
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}>
            <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
          </Form>
        </Space>
      </Modal>
    </React.Fragment>
  );
};

export default RoutePriceForm;
